import { createRoute, redirect } from "@tanstack/react-router";

import { lazyWithRetry } from "@shared/lib/lazy";

import { renderProtectedRoute } from "@app/router/routeElements";
import { rootRoute } from "@app/router/rootRoute";

const coupons = lazyWithRetry(() => import("./routes/coupons"));
const promotions = lazyWithRetry(() => import("./routes/promotions"));

const couponsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/pricing/coupons",
  beforeLoad: () => ({
    breadcrumbs: [
      { label: "Dashboard", to: "/" },
      { label: "Pricing & Taxes" },
      { label: "Coupons" },
    ],
  }),
  component: () =>
    renderProtectedRoute(coupons, { requirePerms: ["pricing:read"] }),
});

const couponCreateRedirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/pricing/coupons/new",
  beforeLoad: () => {
    throw redirect({ to: "/pricing/coupons", replace: true });
  },
  component: () => null,
});

const promotionsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/pricing/promotions",
  component: () =>
    renderProtectedRoute(promotions, { requirePerms: ["pricing:read"] }),
});

export const pricingRouteTree = [
  couponCreateRedirectRoute,
  couponsRoute,
  promotionsRoute,
];
